import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { CareerFatalError } from './FatalError';
export class CareerErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.error('[CareerErrorBoundary]', error, info);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback)
                return this.props.fallback;
            // A nyers exception message szándékosan NEM kerül a látogató elé
            // (belső részleteket szivárogtathatna) — a console.error-ban megvan.
            return (_jsx(CareerFatalError, { title: "Hiba t\u00F6rt\u00E9nt", message: "Az oldal megjelen\u00EDt\u00E9se k\u00F6zben hiba l\u00E9pett fel. K\u00E9rj\u00FCk, t\u00F6ltsd \u00FAjra az oldalt.", onRetry: () => window.location.reload(), retryLabel: "Oldal \u00FAjrat\u00F6lt\u00E9se" }));
        }
        return this.props.children;
    }
}
